export const BlockWrapper: React.FC = ({ children }) => (
  <div className="column is-full px-5 py-0 mt-4 mb-5">
    {children}
  </div>
)